// Imports
import axios from 'axios'

// App Imports
import { API_URL } from '../../../../setup/config/env'

// Actions


// Get detail
export function detail({ userId }) {
  // console.log(vendor)
  return dispatch => {
    return axios.post(API_URL, {
      operation: 'userDetail',
      params: { userId }
    })
  }
}

export function searchByAddress(searchQuery) {
  return dispatch => {
    return axios.post(`${API_URL}/api/address/searchByAddress`,{
      searchQuery
    })
  }
}